

var lib_core  = require("./index.js");
var UserModel = require("./userModel.js");
var $         = require("jquery");

var UserController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
    this.env = configuration.env;
    this.urls = configuration.urls;
};
lib_core.inherit(UserController, lib_core.Controller);

UserController.prototype.beforeLoadPromise = function() {
    var self = this;

    var promise = new Promise(function(resolve, reject) {
        lib_core.Controller.prototype.beforeLoad.call(self);

        self.getModel().noAuthentication(true);

        if(!(self.configuration.auth_required || self.configuration.auth_optional)){
            resolve("NO AUTHORIZATION REQUIRED");
        }else{
            console.log("attempting CS request");

            lib_core.ContentServerHandler.csRequest(
                "GET",
                self.urls['contentServer']['server']+"/"+self.urls['contentServer']['tenant']+"/actions/userIdFromSession",
                { 'Content-Type': 'application/json' },
                null, // no data
                false, // not sync
                true, // json expected
                false, // not form data
                "attempting to load user data (first attempt at connecting).",
                logError.criticality.MINOR
            ).then(function(data){
                self.getModel().name(data["name"]);
                self.getModel().id(data["id"]);
                self.getModel().email(data["email"]);
                self.getModel().avatar(data["avatar"]);
                self.getModel().noAuthentication(false);
                self.getModel().role(data["role"]);
                resolve("AUTHORIZED");
            })
            .catch(function(error){
                console.log("CS request failed");
                if(error.status == 401) {
                  console.log("attempting redirect");
                  self.auth();
                }
                else {
                     logError("Content Server Handler", error, logError.criticality.MAJOR, "attempting to load user data (first attempt at connecting).");
                }
                reject(error);
            });
        }
    });

    promise = promise.then(function() {
        Raygun.setUser(self.getModel().id(), false, self.getModel().email(), self.getModel().name(), null, null);
    });

    return promise;
};

UserController.prototype.createModel = function () {
    return new UserModel();
};

UserController.prototype.forceLogoutAllServices = function(){
    var self = this;
    var logoutURL = self.urls['contentServer']['server'] + "/" +
        self.urls['contentServer']['tenant'] +
        "/actions/logout";
    window.location = logoutURL;
};

UserController.prototype.auth = function(){
    var self = this;
    let redirect = (this.configuration.dontUseWindowForRedirect)? 'https://google.com': window.location;
    var loginURL = self.urls['contentServer']['server'] + "/" +
        self.urls['contentServer']['tenant'] +
        "/actions/login?tenant=circuits&redirect=" + redirect;

    window.location = loginURL;
};

module.exports = UserController;
